import AnimatedList from './AnimatedList'
export default AnimatedList
